<template>
  <div class="baiduQueue">
      <div class="head">
        <img src="/static/index/index15.png" alt="">
        <div class="title">
            <div class="h1">专业技术服务商</div>
            <div class="h2">强大的研发实力，安全稳定的系统支持专业执着，精益求精</div>
        </div>
        <div class="search">
          <div class="s1"><el-cascader placeholder="区域" :options="options" v-model="selectedOptions" @change="handleChangeData" :props="props"></el-cascader></div>
          <div class="s1">
              <img src="/static/index/index11.png" alt="">
              <el-input v-model="input"  @keyup.enter.native="getData" placeholder="企业名称"></el-input>
          </div>
          <div class="s2" @click="getData">查询</div>
      </div>
      </div>
      
      <h1>Industrial Enterpris</h1>
      <h2>工控企业</h2>
      <div class="label">
          <div :class="index==item.typeId?'l1':''"  @click="update(item)" v-for="(item,indexs) in categoryList" :key="indexs">{{item.typeName}}</div>
      </div>
      <div class="box">
          <div @click="jump(item)" v-for="(item,index) in list" :key="index">
              <img :src="item.logoUrl?item.logoUrl:'/static/index/index15.png'" alt="">
              <div class="b1">{{item.orgaName}}</div>
              <div class="b2">所属行业：{{item.industry}}</div>
              <div class="b2">{{item.product}}</div>
              
          </div>
          
      </div>
      <footer1></footer1>
      <!-- <el-pagination
      background
        layout="prev, pager, next"
        :total="1000">
    </el-pagination> -->
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { regionData } from "element-china-area-data";
if(regionData[0].label=='北京市'){
    regionData.unshift({label:'全部',value:'000000',children:[{label:'全部',value:'000000',children:[{label:'全部',value:'000000'}]}]})
}

export default {
  title: "课程列表",
  data() {
    return {
    options: regionData,
    selectedOptions:[],
    props:{
        value:'label',
        label:'label'
    },
      input:'', // 搜索产品输入
      categoryList:[],
      index:'',
      list:[],
      chooseCity:[],

    };
  },
  computed: {},
  components: {},
  methods: {
      jump(e){
          this.$router.push({
            path:'/enterpriseDetail',
            query:{
              id:e.rid
            }
          })
      },
      handleChangeData(value) {
          if(value[0]=="全部"){
              this.chooseCity=[]
              this.selectedOptions=[]
          }else{
              this.chooseCity=value
          }
          this.getData()
    },
    update(e){
      this.index=e.typeId
      this.getData()
    },
    getData() {
      let obj={
					crud:2,
					retailerJson:JSON.stringify({
						orgaName:this.input || null,
						area:this.chooseCity.length==0?null:this.chooseCity[1]!='市辖区'?this.chooseCity[1]:this.chooseCity[0],
						parentId:this.index==0?null:this.index
					})
				}
				this.$axios.post(`/do_oper_retailer`,this.$qs.stringify(obj)).then(res => {
					this.list=res.data.data
				})
    },
  },

  mounted() {
    this.$axios.post(`/do_oper_retailer`,this.$qs.stringify({crud:-2})).then(res => {
      this.categoryList=res.data.data
      this.categoryList.unshift({typeName:'全部',typeId:0})
      this.index=this.categoryList[0].typeId
      this.getData()
    })
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  // display: flex;
  // flex-direction: column;
  // padding-bottom: 50px;
  .head{
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &>img{
        width: 100%;
        height: 100%;
        position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }
    .title{
        width: 1200px;
        z-index: 1;
        .h1{
            font-size: 50px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 44px;
        }
        .h2{
            font-size: 30px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            width: 530px;
        }
    }
    .search{
      width: 1200px;
      height: 135px;
    background: #85A9CD;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 377px;
    transform: translate(-50%,0);
    display: flex;
    align-items: center;
    justify-content: center;
    .s1{
        width: 382px;
        height: 66px;
        border-radius: 6px;
        border: 3px solid #FFFFFF;
        margin-right: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        /deep/ .el-input__inner{
            border: none;
            background: transparent;
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            &::placeholder {
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
            }
        }
        /deep/ .el-input__icon{
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;
        }
        &>img{
            width: 24px;
            height: 24px;
            
        }
        &>.el-input{
            width: 60%;
        }
        
    }
    .s2{
        width: 222px;
        height: 66px;
        background: #FFFFFF;
        border-radius: 6px;
        text-align: center;
        line-height: 66px;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #0457AD;
    }
  }
  }
  
  h1{
      font-size: 40px;
    font-family: BanglaMN;
    color: #999999;
    text-align: center;
    margin-top: 73px;
  }
  h2{
      font-size: 40px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #666666;
        text-align: center;
        margin-bottom: 50px;
  }
  .label{
      display: flex;
      flex-wrap: wrap;
      width: 1200px;
      margin: 0 auto 30px;
        div{
            width: 160px;
            height: 50px;
            background: #FFFFFF;
            border-radius: 33px;
            text-align: center;
            line-height: 50px;
            font-size: 20px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            margin-right: 10px;
            margin-bottom: 10px;
        }
        .l1{
            background: #198AFA;
            color: #FFFFFF;
        }
  }
  .box{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      &>div{
          width: 370px;
        height: 388px;
        background: #FFFFFF;
        margin-right: 45px;
        margin-bottom: 30px;
        img{
            width: 100%;
            height: 204px;
        }
        .b1{
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
            padding: 0 22px;
            margin: 16px 0 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            
        }
        .b2{
            font-size: 24px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
            padding: 0 22px;
            margin-bottom: 12px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
        
      }
      &>div:nth-child(3n){
          margin-right: 0;
      }

  }
}
.el-pagination{
    text-align: center;
    margin-top: 36px;
    /deep/ .el-pager li,/deep/ .btn-next,/deep/ .btn-prev{
        background: transparent;
    }
    /deep/ .el-pager li:not(.disabled).active{
        border-radius: 50%;
        background: #88C0F8;
    }
}
</style>  


// WEBPACK FOOTER //
// src/pages/enterprise/index.vue